import { BoolFilter } from "gen/search/service/service_pb"
import { WebUrl } from "shared-web/lib/webUrl"

export function adminIntegrationsSettings(): WebUrl {
  return {
    pathname: "/admin/integrations/settings",
  }
}

export function adminIntegrationsJournalEntries(): WebUrl {
  return {
    pathname: "/admin/integrations/journal-entries",
    query: { archived: BoolFilter.FALSE.toString() },
  }
}

export function adminIntegrationsJournalEntry(id: string): WebUrl {
  return {
    pathname: `/admin/integrations/journal-entries/${id}`,
  }
}
